export default "__VITE_ASSET__BZrCNkOx__"